<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Request Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="request_date_from"/> ~ <CustomDatePicker v-model="request_date_to"/></span>

				<span class="int_type_no_border mgr_5"> <PartnerSelect v-model="ship_to_code" ph="Ship To" :showName="false" @set-partner="setPartner" /> </span>

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sales_group_code"/></span>

				<span class="int_type">
					<input type="text" style="width:200px" v-model.trim="keyword" placeholder="Scan Keys (Call tag No, UPS No)" autocomplete="off" @keyup.enter="search()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable>
			<thead>
				<tr>
					<th width="4%">Tag No</th>
					<th width="5%">Void / SO No</th>
					<th width="5%">Req. Date</th>
					<!-- <th width="3%">Entry</th> -->
					<th width="5%">Ship To</th>
					<th width="10%">Ship To Name</th>
					<th width="7%">Sales Group</th>
					<th width="8%">Store Name</th>
					<th width="8%">Address</th>
					<th width="5%">City</th>
					<th width="3%">State</th>
					<th width="3%">Zip</th>
					<th width="6%">Telephone</th>
					<!-- <th width="5%">Inv No</th> -->
					<th width="3%">WT(LB)</th>
					<th width="7%">Items</th>
					<th width="7%">Description</th>
					<th width="7%">Tracking No</th>
					<th width="6%">Contact Option</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="tag in call_tags" v-bind:key="tag.call_tag_no">
					<td class="al_left">
						<a href="javascript:;" @click="selectTag(tag)">{{ tag.call_tag_dn }}</a>
					</td>
					<td class="al_left">
						<span v-if="tag.del_yn == 'Y'" style="color:blue;">Void</span>
						<a href="javascript:;" @click="selectSO(tag)">{{ tag.linked_so_dn }}</a>
					</td>
					<td class="al_left">{{ tag.request_date }}</td>
					<!-- <td class="al_left">{{ tag.crt_user }}</td> -->
					<td class="al_left">
						<a href="javascript:;" @click="gotoPartner(tag.ship_to_code)">{{ tag.ship_to_code }}</a>
					</td>
					<td class="al_left truncate">
						<a href="javascript:;" @click="gotoPartner(tag.ship_to_code)">{{ tag.ship_to_name }}</a>
					</td>
					<td class="al_left">{{ tag.sales_group_name }}</td>
					<td class="al_left truncate">{{ tag.store_name }}</td>
					<td class="al_left truncate">
						<span :title="tag.address_detail">{{ tag.address_detail }}</span>
					</td>
					<td class="al_left">{{ tag.address_city }}</td>
					<td class="al_left">{{ tag.address_state }}</td>
					<td class="al_left">{{ tag.address_zipcode }}</td>
					<td class="al_left">{{ tag.telephone }}</td>
					<!-- <td class="al_left truncate">{{ tag.invoice_nos }}</td> -->
					<td class="al_right">{{ tag.weights | calWeightSum | commaSeparated }}</td>
					<td class="al_left truncate">
						<span :title="tag.items">{{ tag.items }}</span>
					</td>
					<td class="al_left truncate">
						<span :title="tag.description">{{ tag.description }}</span>
					</td>
					<td class="al_left truncate">{{ tag.tracking_nos }}</td>
					<td class="al_left truncate">{{ tag.contact_option }}</td>
					<!-- <td class="al_left">{{ item.sales_group_name }}</td>					
					<td class="al_left">{{ item.class_code }}</td>
					<td class="al_left truncate">{{ item.class_name }}</td>
					<td class="al_left">{{ item.color_code }}</td>
					<td class="al_left">
						<a href="javascript:;" @click="selectSO(item)">{{ item.so_dn }}</a>
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="selectInvoice(item)">{{ item.invoice_dn }}</a>
					</td>
					<td class="al_right">{{ item.quantity | commaSeparated }}</td>
					<td class="al_right">{{ item.shipped_quantity | commaSeparated }}</td>
					<td class="al_right">
						<font color="red">{{ item.bo_quantity | commaSeparated }}</font>
					</td>
					<td></td>
					<td></td>
					<td></td> -->
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<li v-if="modifiable"><router-link :to="{ name: 'callTagDetail', params: { mode: 'add' }, query: { backUri: this.uri } }">Add</router-link></li>
			</ul>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectCallTagList } from '@/api/sales/calltag.js';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import { today, daysAgo } from '@/utils/date.js';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			request_date_from: daysAgo(30),
			request_date_to: today(),
			sales_group_code: null,
			ship_to_code: null,

			keyword: null,

			salesGroups: [],

			call_tags: [],

			modalName: '',
			ship_or_bill: '',
			showModal: false,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		CodeSelect,
		PartnerSelect,
	},
	filters: {
		calWeightSum: function(value) {
			var weightSum = 0;
			if (value) {
				var weights = value.split('|');
				weights.forEach(w => {
					weightSum += Number(w);
				});
			}
			return weightSum;
		},
	},
	methods: {
		selectSO(callTag) {
			// if (invoice.invoice_type == 'R') {
			// 	this.$toast.warning('Return SO will be developed later.');
			// 	return;
			// }
			//console.log(invoice);
			this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: callTag.linked_invoice_no } });
		},
		selectTag(tag) {
			this.$router.push({ name: 'callTagDetail', params: { mode: 'detail' }, query: { backUri: this.uri, call_tag_no: tag.call_tag_no } });
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectCallTags(pageNo);
		},
		setPartner(partner) {
			this.ship_to_code = partner.code;
			this.search();
		},
		selectPartner(ship_or_bill) {
			this.ship_or_bill = ship_or_bill;
			this.modalName = 'PartnerSelect';
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		reset() {
			this.request_date_from = daysAgo(30);
			this.request_date_to = today();
			this.sales_group_code = null;
			this.ship_to_code = null;
			this.keyword = null;
		},
		search() {
			this.selectCallTags();
		},
		async selectCallTags(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			//console.log('select invoices');
			//const { data } = await selectAllPensioner();
			var param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				request_date_from: this.request_date_from,
				request_date_to: this.request_date_to,
				sales_group_code: this.sales_group_code,
				ship_to_code: this.ship_to_code,
				keyword: this.keyword,
			};

			const { data } = await apiSelectCallTagList(param);

			//console.log(data);
			this.call_tags = data.callTagList;
			this.list_count = data.list_count; //data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/sales/call_tag?page_no=' + this.page_no;
			if (this.keyword) uri += '&keyword=' + this.keyword;
			if (this.request_date_from) uri += '&request_date_from=' + this.request_date_from;
			if (this.request_date_to) uri += '&request_date_to=' + this.request_date_to;
			if (this.sales_group_code) uri += '&sales_group_code=' + this.sales_group_code;
			if (this.ship_to_code) uri += '&ship_to_code=' + this.ship_to_code;
			/////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		gotoPartner(code) {
			//console.log(code);
			this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
		},
		async index() {
			const { data } = await apiIndex();

			this.salesGroups = data.salesGroupList;
		},
		async init() {
			await this.index();

			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.request_date_from) this.request_date_from = this.$route.query.request_date_from;
			if (this.$route.query.request_date_to) this.request_date_to = this.$route.query.request_date_to;
			if (this.$route.query.sales_group_code) this.sales_group_code = this.$route.query.sales_group_code;
			if (this.$route.query.ship_to_code) this.ship_to_code = this.$route.query.ship_to_code;
			if (this.$route.query.page_no) this.page_no = this.$route.query.page_no;

			await this.selectCallTags(this.$route.query.page_no);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 3);
		this.$store.commit('setSelectedMenu', 'nav_li_call_tag');
		this.$store.commit('setSubTitle', 'Sales -> Call Tag');

		this.init();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
